import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
`;

export const IframeWrapper = styled.div`
    position: relative;
    width: 900px;
`;

export const Controls = styled.div`
    flex: 1;
`;

export const StartVideoText = styled.div`
    text-align: center;
    font-size: 20px;
    margin-top: 80px;
`;

export const RecButton = styled.button`
    margin: auto;
    margin-top: 80px;
    width: 80px;
    height: 80px;
    border-radius: 40px;
    background-color: ${p => p.theme.c.record};
    cursor: pointer;
    border: none;
    box-shadow: 0 0 0 2px ${p => p.theme.c.black} inset;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    outline: none;
    color: ${p => p.theme.c.white};
    font-size: 28px;
    transition: transform 70ms, box-shadow 70ms;

    :active {
        transform: scale(0.93);
        box-shadow: 0 0 0 2px ${p => p.theme.c.black} inset,
            0 0 12px 0 ${p => p.theme.c.blackShadow4};
    }
`;

export const ResetButton = styled.button`
    margin: auto;
    display: block;
    margin-top: 80px;
`;

export const Directions = styled.div`
    font-size: 19px;
    padding: 16px;
    ul {
        padding-left: 24px;
    }
    li {
        margin-bottom: 8px;
    }
`;

export const Buttons = styled.div`
    padding: 16px;
    height: 200px;
`;

export const Completed = styled.div`
    color: ${p => p.theme.c.correct};
    font-size: 19px;
    text-align: center;
    margin-top: 18px;
`;